module.exports = __webpack_public_path__ + "assets/img/103.ca7aaa2e.png";